import {
  Home,
  Settings,
  Webhook,
  LucideIcon,
  Link2,
  Store,
  QrCode,
  Receipt,
  Users,
  Wallet,
} from "lucide-react";

export type RouteConfig = {
  icon: LucideIcon;
  title: string;
};

export const routeConfigs: Record<string, RouteConfig> = {
  "/dashboard": {
    icon: Home,
    title: "Dashboard",
  },
  "/dashboard/home": {
    icon: Home,
    title: "Dashboard",
  },
  "/dashboard/withdraw": {
    icon: Wallet,
    title: "Saques",
  },
  "/dashboard/config": {
    icon: Settings,
    title: "Configurações",
  },
  "/dashboard/merchant": {
    icon: Store,
    title: "Modo Comerciante",
  },
  "/dashboard/customers": {
    icon: Users,
    title: "Clientes",
  },
  "/dashboard/apis": {
    icon: Webhook,
    title: "API e Webhooks",
  },
  "/dashboard/qrcode": {
    icon: Link2,
    title: "Criar Link de Pagamento",
  },
  "/dashboard/payment-links": {
    icon: Link2,
    title: "Links de Pagamento",
  },
  "/dashboard/transactions": {
    icon: Receipt,
    title: "Transações",
  },
  "/dashboard/settings": {
    icon: Settings,
    title: "Configurações",
  },
};

export const getRouteConfig = (pathname: string): RouteConfig => {
  // Try exact match first
  if (routeConfigs[pathname]) {
    return routeConfigs[pathname];
  }

  // Try partial match for dynamic routes
  const matchedRoute = Object.keys(routeConfigs).find(
    (route) => route !== "/dashboard" && pathname.startsWith(route),
  );

  return matchedRoute ? routeConfigs[matchedRoute] : routeConfigs["/dashboard"];
};
